/* tslint:disable */
/* eslint-disable */
export enum JofiCurrentSchoolYearEnum {
  EnumsCurrentSchoolYearYear8 = 'enums.currentSchoolYear.year8',
  EnumsCurrentSchoolYearYear9 = 'enums.currentSchoolYear.year9',
  EnumsCurrentSchoolYearYear10 = 'enums.currentSchoolYear.year10',
  EnumsCurrentSchoolYearYear10Plus = 'enums.currentSchoolYear.year10plus'
}
